import React from 'react';
import { CheckCircle2Icon, Clock3Icon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { Badge } from '../Badge';
import { CtaButton } from '../CtaButton';
import { Logo } from '../Logo';
import { IMAGES } from '../../lib/content';
const TRUST_CHIPS = ['✓ No money up front.', '✓ No commitment.', '✓ Full deposit refund in 7 days if you change your mind.'];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-white" data-id="element-57" data-mp="mutwjsjt0jda">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-58" data-mp="qvm6yp4ewub5">
        <div className="absolute -top-32 -right-24 h-96 w-96 rounded-full bg-[#A9DFE9]/40 blur-3xl" data-id="element-59" data-mp="qtjapnco24xz" />
        <div className="absolute top-1/2 -left-32 h-80 w-80 rounded-full bg-[#26B3CA]/15 blur-3xl" data-id="element-60" data-mp="voor66naureo" />
      </div>

      <div className="relative mx-auto flex max-w-6xl items-center justify-between px-6 py-6" data-id="element-61" data-mp="15kif0m6gy7br">
        <Logo size="md" aria-label="Pler Smile home" data-id="element-62" data-mp="1ajmlv65x7syx" />
        <div className="hidden items-center gap-2 text-sm font-semibold text-[#1F6E7B] sm:flex" data-id="element-63" data-mp="1akeeq984vcli">
          <ShieldCheckIcon size={16} data-id="element-64" data-mp="9olxq9grhynd" />
          Dadeland, Kendall, Miami
        </div>
      </div>

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-6 pb-16 pt-6 lg:grid-cols-2 lg:pb-24 lg:pt-10" data-id="element-65" data-mp="4nyazzzkg3yy">
        <div className="flex flex-col" data-id="element-66" data-mp="3vwu6i02joie0">
          <div className="mb-6 flex flex-wrap gap-2" data-id="element-67" data-mp="3ru797jn3u59f">
            <Badge variant="aqua" size="sm" data-id="element-68" data-mp="3rvs8tnoa0ee5">All-on-X Dental Implants</Badge>
            <Badge variant="sky" size="sm" data-id="element-69" data-mp="sditkhrt4z7p">Pler Smile Dadeland</Badge>
            <Badge variant="outline" size="sm" data-id="element-70" data-mp="ng8ueaem996o">5-Day Smile Experience</Badge>
          </div>

          <div className="mb-5 inline-flex w-fit items-center gap-2 rounded-full bg-[#1A1A2E] px-4 py-2 text-sm font-semibold text-white" data-id="element-71" data-mp="inph7ejucg2e">
            <Clock3Icon size={16} className="text-[#A9DFE9]" data-id="element-72" data-mp="emnicytu660y" />
            Only 3 clinical openings remain this month
          </div>

          <h1 className="text-4xl font-bold leading-[1.05] tracking-tight text-[#1A1A2E] md:text-5xl lg:text-6xl" data-id="element-73" data-mp="16ebr7bdeoaf1">
            5 Days in Miami.
            <span className="mt-2 block text-[#1F6E7B]" data-id="element-74" data-mp="30n8lakvoa2t3">Leave With Your Final Zirconia Smile.</span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-[#1A1A2E]/80" data-id="element-75" data-mp="35k8n2jlhojee">
            Complete All-on-X surgery with 3D facial design, four hotel nights, and airport
            transportation included. Start with one arch from{' '}
            <span className="font-bold text-[#1A1A2E]" data-id="element-76" data-mp="2hvpf656cq8mu">$20,000</span>. If your diagnostic plan calls for
            full mouth treatment, both arches begin at <span className="font-bold text-[#1A1A2E]" data-id="element-77" data-mp="2mw3odqjovomg">$35,000</span>.
          </p>

          <div className="mt-6 rounded-2xl border border-[#26B3CA]/30 bg-[#A9DFE9]/20 p-4" data-id="element-78" data-mp="27yjq12hasrp9">
            <div className="flex items-start gap-3" data-id="element-79" data-mp="2cxe4xtc59w43">
              <CheckCircle2Icon size={20} className="mt-0.5 shrink-0 text-[#1F6E7B]" data-id="element-80" data-mp="2cy60j45qrtud" />
              <p className="text-sm leading-relaxed text-[#1A1A2E]/85" data-id="element-81" data-mp="63sh70r0q2jn">
                Your complete care package is valued at approximately{' '}
                <strong className="text-[#1A1A2E]" data-id="element-82" data-mp="1vm906wsxslei">$34,670</strong>. You receive your final
                zirconia bridge before flying home, not a temporary acrylic smile.
              </p>
            </div>
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-83" data-mp="25eenvuc5ognw">
            <CtaButton data-id="element-84" data-mp="20l2bcikr40bi" />
          </div>
          <div className="mt-3 flex flex-wrap gap-2" aria-label="Booking protections" data-id="element-85" data-mp="20k0qjmdxnzgl">
            {TRUST_CHIPS.map(chip => <span key={chip} className="rounded-full border border-[#A9DFE9] bg-white px-3 py-1.5 text-xs font-semibold text-[#1A1A2E]" data-id="element-86" data-mp="2ac6ordus3d48">
                {chip}
              </span>)}
          </div>

          <div className="mt-4 border-y border-[#A9DFE9]/60 py-3 text-[10px] font-bold uppercase tracking-[0.08em] text-[#1F6E7B] sm:text-xs" data-id="element-87" data-mp="2jcbmsxe30z5q">
            Pler Smile Clinical Team · ADA Member · AAID Accredited · AACD Certified · Straumann® Advanced Provider
          </div>

          <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-[#1A1A2E]/75" data-id="element-88" data-mp="qfr5b8kfjdng">
            <span className="inline-flex items-center gap-1.5 font-semibold text-[#1A1A2E]" data-id="element-89" data-mp="vekamdpkbycj">
              <StarIcon size={16} className="fill-[#26B3CA] text-[#26B3CA]" data-id="element-90" data-mp="10dx61mui2dqq" />
              4.9 rating
            </span>
            <span data-id="element-91" data-mp="15d9uud4xluvy">250+ smiles transformed</span>
            <span data-id="element-92" data-mp="15c8g9yopiq9h">Pler Smile Miami</span>
            <span data-id="element-93" data-mp="7pro17utz2ul">Certified full arch rehabilitation team</span>
          </div>
        </div>

        <div className="relative" data-id="element-94" data-mp="co2wbe5h95ap">
          <div className="overflow-hidden rounded-[2rem] shadow-soft ring-1 ring-[#A9DFE9]/60" data-id="element-95" data-mp="cp48jly8bxu0">
            {/* TODO-IMAGE: replace with real onsite photo; consent on file with admin team */}
            <img src={IMAGES.hero} alt="Patient smiling confidently after her All-on-X treatment at Pler Smile Dadeland" className="h-full w-full object-cover" loading="eager" data-id="element-96" data-mp="mf79q9fi8i3f" />
          </div>
          <div className="absolute -bottom-5 -left-5 hidden rounded-2xl bg-white px-5 py-4 shadow-soft ring-1 ring-[#A9DFE9]/60 sm:block" data-id="element-97" data-mp="2784kornb0465">
            <div className="text-2xl font-bold text-[#1F6E7B]" data-id="element-98" data-mp="237kih9nviad5">5 days</div>
            <div className="text-xs font-medium uppercase tracking-wide text-[#1A1A2E]/70" data-id="element-99" data-mp="1y6wu6vr147mm">to your final smile</div>
          </div>
        </div>
      </div>
    </section>;
}